export interface SearchableMenu {
  [key: string]: any
  fullPath: string
  displayTitle: string
}

type Translate = (key: string) => string

const I18N_KEY_PATTERN = /^[a-zA-Z][\w-]*(?:\.[\w-]+)+$/

const getDisplayTitle = (route: any, translate: Translate): string => {
  const originalTitle = String(route.meta?.title ?? route.title ?? '').trim()
  if (!originalTitle) return ''

  if (!I18N_KEY_PATTERN.test(originalTitle)) return originalTitle

  const translatedTitle = String(translate(originalTitle) || '').trim()
  return translatedTitle && translatedTitle !== originalTitle ? translatedTitle : ''
}

export const buildSearchableMenus = (
  routes: any[] = [],
  translate: Translate,
  parentPath = ''
): SearchableMenu[] => {
  const result: SearchableMenu[] = []

  for (const route of routes) {
    if (!route || route.type === 'btn' || route.meta?.hidden || route.hidden) continue

    const routePath = String(route.path || '')
    const fullPath = (routePath.startsWith('/') ? routePath : `${parentPath}/${routePath}`).replace(
      /\/+/g,
      '/'
    )
    const childMenus = buildSearchableMenus(route.children || [], translate, fullPath)
    const displayTitle = getDisplayTitle(route, translate)

    // 根布局只负责承载首页，不作为单独菜单，避免搜索结果出现两个“首页”。
    if (routePath !== '/' && displayTitle) {
      result.push({
        ...route,
        fullPath,
        displayTitle
      })
    }

    result.push(...childMenus)
  }

  return result
}

export const searchMenus = (menus: SearchableMenu[], keyword: string): SearchableMenu[] => {
  const normalizedKeyword = keyword.trim().toLocaleLowerCase()
  if (!normalizedKeyword) return []

  return menus.filter((menu) => menu.displayTitle.toLocaleLowerCase().includes(normalizedKeyword))
}
